import angular from 'angular';

import FechaConfig from './fecha.config';
import PaginacionConfig from './paginacion.config';
import SugerenciaConfig from './sugerencia.config';
import URLConfig from './url.config';
import TipoBusquedaConfig from './tipo-busqueda.config';
import TipoRegistroConfig from './tipo-registro.config';
import CampoBusquedaConfig from './campo-busqueda.config';
const MODULE_NAME = 'buscador.config';

const ngModule=angular.module(MODULE_NAME, []);

ngModule
            .constant('urlConfig',URLConfig)
            .constant('paginacionConfig', PaginacionConfig)
	        .constant('fechaConfig', FechaConfig)
	        .constant('tipoBusquedaConfig', TipoBusquedaConfig)
	        .constant('tipoRegistroConfig', TipoRegistroConfig)
            .constant('campoBusquedaConfig', CampoBusquedaConfig)
            .constant('sugerenciaConfig', SugerenciaConfig);


export default MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/config/index.js